module.exports = __webpack_public_path__ + "static/img/bg-ar.a090a92a.png";